var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"succ"},[_c('img',{attrs:{"src":require("@/assets/resetPassword/success.png"),"alt":""}}),_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.i18n('223')))]),_c('div',{staticClass:"but",on:{"click":function($event){return _vm.$router.replace('/loginRegistration?type=1')}}},[_vm._v(" "+_vm._s(_vm.i18n('56'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }